import * as types from "../types";

const initialState = {
    unique: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_RESTAURANT:
            return { ...state, unique: action.payload };

        default:
            return { ...state };
    }
};

export default reducer;
